import type { SubstitutabilityAttributes } from 'types/substitutability';
import { TAG_TYPES } from 'types/services';
import { coreApi } from '.';

export const substitutabilityService = coreApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getSubstitutability: builder.query<SubstitutabilityAttributes, void>({
      query: () => ({
        url: 'Substitutability',
        method: 'GET',
      }),
      providesTags: [TAG_TYPES.SUBSTITUTABILITY],
    }),
    updateSubstitutability: builder.mutation<SubstitutabilityAttributes, SubstitutabilityAttributes>({
      query: (data) => ({
        url: 'Substitutability',
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: [TAG_TYPES.SUBSTITUTABILITY],
    }),
  }),
});
export const { useGetSubstitutabilityQuery, useUpdateSubstitutabilityMutation } = substitutabilityService;
